import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { NgxDatatableModule } from '@m3rlin94/ngx-datatable';
import { TaxonomyButtonComponent } from '../taxonomy-button/taxonomy-button.component';
import { FormsModule } from '@angular/forms';
import { EntityFormComponent } from './entity-form/entity-form.component';
import { ActionService } from '../../../services/action.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DropdownObjectType } from '../../../shared/types';
import { TaxonomyService } from '../../../services/taxonomy.service';
import { TaxonomyApiService } from '../../../services/api-services/taxonomy-api.service';
import { CommonService } from '../../../services/common.service';
import { LocalTaxonomy } from '../taxonomy.model';
import { EmptySelectionTaxonomy, TaxonomyFilterContent } from '../taxonomy.constants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-taxonomy-entity-hub-v2',
  standalone: true,
  imports: [CommonModule, NgxDatatableModule, TaxonomyButtonComponent, CommonModule, FormsModule, EntityFormComponent],
  templateUrl: './taxonomy-entity-hub-v2.component.html',
  styleUrl: './taxonomy-entity-hub-v2.component.scss',
  animations: [
    trigger('contentAnimation', [
      state(
        'void',
        style({
          maxHeight: '0',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      state(
        '*',
        style({
          maxHeight: '300px',
          opacity: 1,
        })
      ),
      transition('void <=> *', animate('300ms ease-in-out')),
    ]),
  ],
})
export class TaxonomyEntityHubV2Component {
  columnsHeader = [
    { prop: 'sequence_no', name: '#' },
    { prop: 'entity_name', name: 'ENTITY NAME' },
    { prop: 'entity_type', name: 'ENTITY TYPE' },
    { prop: 'entity_description', name: 'DESCRIPTION' },
    { prop: 'intents', name: 'INTENTS' },
  ];

  rowsValues: any[] = [];

  searchTerm: string = '';

  filteredRows = [...this.rowsValues];

  constructor(
    public actionsService: ActionService,
    public taxonomyService: TaxonomyService,
    private taxonomyApiService: TaxonomyApiService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute
  ) {}

  filterRows() {
    const term = this.searchTerm.toLowerCase();
    this.filteredRows = this.rowsValues.filter(
      (row) => row.entity_name.toLowerCase().includes(term) || row.entity_type.toLowerCase().includes(term)
    );
  }

  _selectedFilter = signal<DropdownObjectType>(TaxonomyFilterContent[0]);
  _taxonomiesCards = computed<any>(() => this.taxonomyService._taxonomiesData());
  _filterContent = signal<Array<DropdownObjectType>>(TaxonomyFilterContent);
  _searchText = signal<string>('');
  isOpen = false;

  ngOnInit() {
    // Trigger the getTaxonomy method when the update/delete event occurs
    this.taxonomyService.updateTaxonomy$.subscribe(() => {
      this.loadTaxonomy();
    });

    // Subscribe to route params to detect changes in ID
    this.activatedRoute.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.fetchTaxonomyData(id);
      } else {
        console.log('NO ID provided');
      }
    });

    // Listen for updates and refresh the table
    this.taxonomyService.updateTaxonomy$.subscribe(() => {
      const id = this.activatedRoute.snapshot.paramMap.get('id');
      if (id) {
        this.fetchTaxonomyData(id);
      }
    });
  }

  fetchTaxonomyData(id: string) {
    this.taxonomyApiService.getEntitiesV2ByTaxonomyId({ taxonomy_id: id }).subscribe((res) => {
      if (res.success && res.data) {
        this.rowsValues = res.data.entities.map(
          (
            entity: {
              EntityId: string;
              EntityName: string;
              EntityType: string;
              EntityDescription: string;
              LinkedEntities: any[];
            },
            index: number
          ) => ({
            sequence_no: index + 1,
            id: entity.EntityId,
            entity_name: entity.EntityName,
            entity_type: entity.EntityType,
            entity_description: entity.EntityDescription,
            intents: entity.LinkedEntities?.map((linked) => linked.label) || [],
          })
        );

        // Ensure table updates
        this.filteredRows = [...this.rowsValues];
      }
    });
  }

  loadTaxonomy() {
    this.taxonomyApiService.getTaxonomyV2({}).subscribe((res) => {
      this.taxonomyService.getListOfTaxonomies(res);
      this.taxonomyService.setTaxonomiesData(res);
      const content: DropdownObjectType[] = res.taxonomy
        .map((item) => ({ label: item.taxonomy_name, value: item.taxonomy_name }))
        .filter((value, index, self) => index === self.findIndex((t) => t.value === value.value));

      this._filterContent.set([
        {
          label: 'All Entities',
          value: 'all',
        },
        ...content,
      ]);
    });
  }

  getTaxonomyCards = () => {
    let data = this._taxonomiesCards();
    return data;
  };

  onSearchChange(event: Event) {
    const el = event.target as HTMLInputElement;
    this._searchText.set(el.value);
  }

  handleFilterSelect(filter: DropdownObjectType) {
    this._selectedFilter.set(filter);
  }

  handleCreateEntity() {
    this.taxonomyService.entitityFormFlag = 'create';
    this.taxonomyService.setTaxonomyItem({ ...EmptySelectionTaxonomy });
    this.actionsService.openAddEntityForm();
  }

  handleCardSelect(cardData: LocalTaxonomy) {
    this.taxonomyService.setTaxonomyItem(cardData);
    this.actionsService.openAddEntityForm();
  }

  toggle(event: MouseEvent) {
    this.isOpen = !this.isOpen;
    event.stopPropagation();
  }

  onOverlayPress() {
    this.taxonomyService.setTaxonomyItem({ ...EmptySelectionTaxonomy });
    this.actionsService.closeAddEntityForm();
  }
  openEnitityForm(row: any) {
    this.taxonomyService.entitityFormFlag = 'update';
    this.actionsService.displayForm = true;
    this.taxonomyService.enitity = {
      taxonomy_id: this.taxonomyService.selectedTaxonomy?.taxonomy_id,
      entity_id: row.id,
    };
  }
}
